import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SwichBackToPythonComponent } from '../layout/swich-back-to-python/swich-back-to-python.component';
import { VideoPlayerComponent } from '../shared/video-player/video-player.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { LrtdrtavailablityComponent } from './global-popup/lrtdrtavailablity.component';


@NgModule({
    imports: [
        CommonModule,
        PopoverModule.forRoot(),
        SwichBackToPythonComponent,
        VideoPlayerComponent
    ],
    declarations: [
        LrtdrtavailablityComponent
    ],
    exports: [
        SwichBackToPythonComponent,
        LrtdrtavailablityComponent,
        VideoPlayerComponent
    ]
})
export class SharedModuleModule { }
